<template>
	<main>
		<h1>New API token</h1>

		<ApiTokenForm />
	</main>
</template>

<script>
import ApiTokenForm from '../components/ApiTokenForm'

export default {
	name: 'ApiTokenNew',
	components: {
		ApiTokenForm,
	},
};
</script>
